import { FileExcelFilled } from '@ant-design/icons';
import { ExpensesServices } from '@gtpl/shared-services/finance';
import { Button, Card, Row, Table } from 'antd';
import { Excel } from 'antd-table-saveas-excel';
import { ColumnProps } from 'antd/es/table';
import React from 'react';
import { useEffect, useState } from 'react';
import { render } from 'react-dom';
import { Link } from 'react-router-dom';

export const FinanceExpensesView = () => {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState<number>(10);
  const service = new ExpensesServices();
  const [data, setData] = useState<any[]>([]);

  useEffect(() => {
    getInfo();
  }, []);

  const getInfo = () => {
    service.getExpenses().then((res) => {
      if (res.status) {
        setData(res.data);
      }
    });
  };

  const columns: any[] = [
    {
      title: 'SNo',
      key: 'sno',
      responsive: ['sm'],
      render: (text, object, index) =>
        (page - 1) * pageSize + (index + 1) + pageSize * (page - 1),
    },
    {
      title: 'Head',
      dataIndex: 'head',
    },
    {
      title: 'Category',
      dataIndex: 'category',
      // align:'right'
    },
    {
      title: 'Month',
      dataIndex: 'month',
      // align:'right'
    },
    {
      title: 'Year',
      dataIndex: 'year',
      // align:'right'
    },
    
    {
      title: 'Amount',
      dataIndex: 'amount',
      // align:'right'
    },
    {
      title: 'Type',
      dataIndex: 'type',
      // align:'right'
    },
  ];

  let i = 1;
  let rowIndex = 1;

  const exceldata :any= [

    {
      title: "SNo",
      // dataIndex: "sno", 
      width: 50,
      render: (text, object, index) => {
        if (index == data.length) {
          return null;
        } else {
          return rowIndex++;
        }
      }
    },
    
    {
      title: 'Head',
      dataIndex: 'head',
      render: (text: any, record: any) => {
        return record.head ? record.head : '-';
      },
    },
    {
      title: 'Category',
      dataIndex: 'category',
      render: (text: any, record: any) => {
        return record.category ? record.category : '-';
      },
    },
    {
      title: 'Month',
      dataIndex: 'month',
      render: (text: any, record: any) => {
        return record.month ? record.month : '-';
      },
    },
    {
      title: 'Year',
      dataIndex: 'year',
      render: (text: any, record: any) => {
        return record.year ? record.year : '-';
      },
    },
    {
      title: 'Amount',
      dataIndex: 'amount',
      render: (text: any, record: any) => {
        return record.amount ? record.amount : '-';
      },
    },
    {
      title: 'Type',
      dataIndex: 'type',
      render: (text: any, record: any) => {
        return record.type ? record.type : '-';
      },
    },
  ];

  const exportExcel = () => {
    const excel = new Excel();
    excel
      .addSheet('Expenses Excel')
      .addColumns(exceldata)
      .addDataSource(data, { str2num: true })
      .saveAs('Finance_Expenses.xlsx');
  };
  return (
    <Card
      title="Expenses"
      extra={
        <Link to="/Finance-expenses">
          <span style={{ color: 'white' }}>
            <Button type={'primary'}>Upload Excel</Button>{' '}
          </span>
        </Link>
      }
    >
      <Row justify={'end'}>
        <Button
          type="default"
          style={{ color: 'green' }}
          onClick={exportExcel}
          icon={<FileExcelFilled />}
        >
          Download Excel
        </Button>
      </Row>
      <Table
        className="custom-table-wrapper"
        columns={columns}
        dataSource={data}
        size="small"
        pagination={{
          pageSize: 100,
          onChange(current, pageSize) {
            setPage(current);
            setPageSize(pageSize);
          },
        }}
      />
    </Card>
  );
};

export default FinanceExpensesView;
